/**
 * @module
 * @format
 */

import {extend} from '@acng/frontend-bounty/object.js';
import {make, media} from 'acng/core/service/env.js';
import {getBonusModule} from 'acng/payment/service/template.js';
import {IMAGE_FORMATS, BONUS_NAMES} from 'acng/payment/model/bonus.js';
import {user} from 'acng/user/user.js';
import {ACNG} from 'acng/app.js';

class PaymentFeature {
  /**
   * @returns {Promise<{headline: string, imageUrl: string}[]>|null}
   */
  get bonusTeaserList() {
    return user.tester ? this.#getBonusOverview() : null;
  }

  async #getBonusOverview() {
    const {getImageUrl} = await getBonusModule();
    const lang = user.lang;
    const acng = make(ACNG);
    /**
     * @type {{headline: string, imageUrl: string}[]}
     */
    const list = [];
    for (const fsk of /** @type {const} */ ([18, 12])) {
      for (const bonusName of BONUS_NAMES) {
        for (const format of IMAGE_FORMATS) {
          try {
            const config = extend(acng, {
              user: {
                fsk,
                lang,
              },
            });

            list.push({
              headline: `${bonusName}-${format}-${lang}-${fsk}`,
              imageUrl: media.assets_ext + '/' + getImageUrl(config, bonusName, format),
            });
          } catch (err) {
            // an exception means this bonus variant does not exist
          }
        }
      }
    }

    return list;
  }
}

export {PaymentFeature};
